import { Component, effect, Input } from '@angular/core';
import { Leg } from '@approot/models';
import { LegService } from '@approot/services/leg/leg.service';
import { ActiveAttributesPipe } from '@approot/shared/pipes';

@Component({
  selector: 'active-attributes',
  templateUrl: './active-attributes.component.html',
  styleUrls: ['./active-attributes.component.scss'],
  providers: [ActiveAttributesPipe]
})
export class ActiveAttributesComponent {
  @Input() public rfqExecution = false;
  @Input() public legs: Leg[];
  @Input() public genericMultiHedge = false;
  public labelsToHide = [];

  public constructor(
    public legService: LegService,
    private activeAttributesPipe: ActiveAttributesPipe
  ) {
    effect(() => {
      if (!this.legs?.length) {
        return;
      }
      this.labelsToHide = [];
      this.legs.forEach(leg => {
        this.activeAttributesPipe
          .transform(
            this.legService.activeAttributes(),
            leg.attributesAsFormControls
          )
          .forEach(activeAttribute => {
            if (
              activeAttribute?.hideInRfqPanel &&
              !this.labelsToHide.includes(activeAttribute.key)
            ) {
              this.labelsToHide.push(activeAttribute.key);
            }
          });
      });
    });
  }
}
